import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class ProductsController implements Controller {
  public pageId = 'Products';
  public path = '/:localeName/products';
  public routeName = 'products';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/products-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Products' }) as Promise<PageData>;
  }
}
